import { Action, EventName, Method, NO_VALUE } from '../../constants.js';
export const buildButtonClickPayload = (buttonClickParams) => {
    const { uniqueName, componentTitle, loginSource, componentState, pageName } = buttonClickParams;
    const trackingPayload = {
        method: Method.LINK,
        triggeringEventPlace: {
            componentId: componentTitle,
            linkName: `${uniqueName}Click`,
        },
        trackingData: {
            allowLinkBeforeView: true,
            pageName: pageName,
            pageType: pageName,
            elementActioned: uniqueName,
            pageButtonType: `${uniqueName}Click`,
            loginSource: loginSource,
            componentState: NO_VALUE,
            elementAction: Action.CLICK,
            eventName: EventName.CLICK,
            elementActionValue: NO_VALUE,
            componentName: componentTitle,
            ...(componentState && { componentState }),
        },
    };
    return trackingPayload;
};
//# sourceMappingURL=buildButtonClickPayload.js.map